import { http } from '../../../api'

const taskRememberFind = {
  namespaced: true,
  state: {
    task: null
  },
  actions: {
    createTask: ({ commit }, params) => {
      return http.post('/task-remember-find', params).then(res => {
        return res.data
      })
    },
    getTask: ({ commit }, params) => {
      return http.get('/task-remember-find/' + params).then(res => {
        commit('setTask', res.data)
      })
    },
    updateTask: ({ commit }, params) => {
      return http.post('/task-remember-find/' + params.id, params.data).then(res => {
      })
    },
    deleteWord: ({ commit }, params) => {
      return http.post('/task-remember-find/delete-words', params).then(res => {
      })
    }
  },
  mutations: {
    setTask (state, data) {
      state.task = data
    }
  },
  getters: {
    task: state => state.task
  }
}

export default taskRememberFind
